'use strict';

module.exports = {
    initSlider: function () {
        const $sliderFor = $('.slider-for');
        const $sliderNav = $('.slider-nav');
        const $prevArrow = $('.thumb-prev');
        const $nextArrow = $('.thumb-next');

        $sliderFor.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            infinite: false,
            arrows: true,
            swipe: true,
            dots: false,
            prevArrow: $('.main-prev'),
            nextArrow: $('.main-next'),
            responsive: [
                {
                    breakpoint: 999,
                    settings: {
                        dots: true,
                        arrows: false,
                        infinite: true
                    }
                }
            ]
        });

        /**
         * Shows / hides thumbnail arrows based on scroll position
         */
        function updateThumbArrows() {
            const scrollTop = $sliderNav.scrollTop();
            const scrollHeight = $sliderNav.prop('scrollHeight');
            const containerHeight = $sliderNav.outerHeight();
            const isAtTop = scrollTop <= 0;
            const isAtBottom = scrollTop + containerHeight >= scrollHeight - 20;

            $prevArrow.toggle(!isAtTop);
            $nextArrow.toggle(!isAtBottom);
        }

        /**
         * Scrolls thumbnail container so active thumb is visible
         */
        function scrollToActiveThumb() {
            const $activeThumb = $('.thumb-wrapper.active');
            if (!$sliderNav.length || !$activeThumb.length) return;

            const thumbTop = $activeThumb.position().top;
            const thumbHeight = $activeThumb.outerHeight();
            const navHeight = $sliderNav.outerHeight();
            const scrollTop = $sliderNav.scrollTop();

            if (thumbTop < 0) {
                $sliderNav.scrollTop(scrollTop + thumbTop);
            } else if (thumbTop + thumbHeight > navHeight) {
                $sliderNav.scrollTop(
                    scrollTop + thumbTop - navHeight + thumbHeight
                );
            }

            updateThumbArrows();
        }

        /**
         * Scroll thumbnail list by amount
         * @param {number} offset offset to scroll
         */
        function scrollThumbs(offset) {
            $sliderNav.animate(
                { scrollTop: $sliderNav.scrollTop() + offset },
                250,
                updateThumbArrows
            );
        }

        $sliderFor.on('beforeChange', function () {
            $sliderFor.find('video').each(function () {
                this.pause();
                this.currentTime = 0;
            });
        });

        $sliderFor.on('afterChange', function (event, slick, currentSlide) {
            const video = $(slick.$slides[currentSlide]).find('video').get(0);
            if (video) {
                video.play();
            }
        });

        $sliderFor.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.thumb-wrapper').removeClass('active');
            $('.thumb-wrapper[data-index="' + nextSlide + '"]').addClass('active');
            scrollToActiveThumb();
        });

        $(document).on('click', '.thumb-wrapper', function () {
            const index = $(this).data('index');
            $sliderFor.slick('slickGoTo', index);
            $('.thumb-wrapper').removeClass('active');
            $(this).addClass('active');
            scrollToActiveThumb();
        });

        $prevArrow.on('click', function () {
            scrollThumbs(-120);
        });

        $nextArrow.on('click', function () {
            scrollThumbs(120);
        });

        $sliderNav.on('scroll', updateThumbArrows);

        // Make gallery focusable
        $sliderFor.attr('tabindex', '0');

        let isHovering = false;
        $('.primary-images').on('mouseenter', function () {
            isHovering = true;
        }).on('mouseleave', function () {
            isHovering = false;
        });

        $(document).on('keydown', function (e) {
            if (!isHovering) return;

            switch (e.key) {
                case 'ArrowUp':
                    e.preventDefault();
                    $sliderFor.slick('slickPrev');
                    break;

                case 'ArrowDown':
                    e.preventDefault();
                    $sliderFor.slick('slickNext');
                    break;

                case 'ArrowLeft':
                    e.preventDefault();
                    $sliderFor.slick('slickPrev');
                    break;

                case 'ArrowRight':
                    e.preventDefault();
                    $sliderFor.slick('slickNext');
                    break;

                default:
                    break;
            }
        });

        updateThumbArrows();
    }
};
